import SettingsApp from '../Functionality/SettingsApp';
import AttendanceColor from './AttendanceColor';
import FoodieSetting from './FoodieSetting';
import ManageButtonsHeader from "./ManageButtonsHeader";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param {Function} props.handleBtnDinning - Callback to switch to dining view.
 * @param {Function} props.handleBtnSettings - Callback to switch to settings view.
 * @param {Function} props.handleBtnDepartmentPolicies - Callback to switch to department policies view.
 * @param {Function} props.handleBtnTotalMeals - Callback to switch to total meals view.
 * @returns {JSX.Element}
 */
const Settings = ({
    subView,
    handleBtnDinning,
    handleBtnSettings,
    handleBtnDepartmentPolicies,
    handleBtnTotalMeals,
    color,
    setColor
}) => {
    const {
        handleChange,
        item,
        onChange,
        emptyFields,
        pricePlaceholder,
        isValidSelectionMenuDelay,
        onCostChange
    } = SettingsApp({
        color,
        setColor
    });


    return (<>
        <div className='row px-0 '>
            <div className='d-flex gap-3 px-0'>
                <ManageButtonsHeader
                    subView={subView}
                    handleBtnDinning={handleBtnDinning}
                    handleBtnSettings={handleBtnSettings}
                    handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                    handleBtnTotalMeals={handleBtnTotalMeals}
                />
            </div>
            <AttendanceColor
                item={color}
                onChange={handleChange}
            />
            <FoodieSetting
                item={item}
                onChange={onChange}
                emptyFields={emptyFields}
                pricePlaceholder={pricePlaceholder}
                isValidSelectionMenuDelay={isValidSelectionMenuDelay}
                onCostChange={onCostChange}
            />
        </div>

    </>)

}

export default Settings;
